import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const Alerts = ({ alert, clang }) => {
    if (!alert || !alert.message) {
        return null;
    }
    
    return (
        <div className={`alert ${alert.type}`}>{lang[clang].alerts[alert.message]}</div>
    );
};

Alerts.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(Alerts);



// WEBPACK FOOTER //
// ./src/components/alerts/Alerts.js